/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_ResetInputs */

const fr_psod_reset = /** @type {(inputs: Psod_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser l'app`)
};

const en_psod_reset = /** @type {(inputs: Psod_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset the app`)
};

/**
* | output |
* | --- |
* | "Reset the app" |
*
* @param {Psod_ResetInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_reset = /** @type {((inputs?: Psod_ResetInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_ResetInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_reset(inputs)
	return en_psod_reset(inputs)
});